import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../store/hooks';
import { fetchWhatsAppNumbers } from './whatsAppMessageThunks';
import { useIsCoreItemEnabled } from '../../plugin/useCoreItems';

/**
 * USE WHATSAPP ENABLED — la company ha almeno un numero WhatsApp business. Senza,
 * la pagina WhatsApp (FILO-37) non è nel menu e non si apre. `undefined` finché
 * la risposta non arriva; un errore conta come «nessun numero».
 *
 * Spenta dalla pagina «Voci del CRM» (FILO-53) vale `false` anche con i numeri, e i numeri non si
 * chiedono: così si adeguano insieme la voce, la pagina e il pulsante della scheda contatto.
 */
export function useWhatsAppEnabled(): boolean | undefined {
  const dispatch = useAppDispatch();
  const itemEnabled = useIsCoreItemEnabled('whatsapp');
  const [enabled, setEnabled] = useState<boolean>();

  useEffect(() => {
    if (!itemEnabled) return;
    async function load() {
      try {
        setEnabled((await dispatch(fetchWhatsAppNumbers()).unwrap()).length > 0);
      } catch {
        setEnabled(false);
      }
    }
    void load();
  }, [dispatch, itemEnabled]);

  return itemEnabled ? enabled : false;
}
